// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"614":"component---src-pages-editor-js","712":"component---src-templates-storyblok-entry-tsx"}[chunkId] || chunkId) + "-" + {"454":"408c1acffd4919854027","614":"f3e3977ef5455e164aa7","712":"6305cb0f840b1b852dd1"}[chunkId] + ".js";
};